import styled, { keyframes } from 'styled-components';

export const ScrollMenuBar = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
  z-index: 1000;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transform: ${({ $isVisible }) => ($isVisible ? 'translateY(0)' : 'translateY(-100%)')};
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const slideInFromTop = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const MenuWrapper = styled.div<{ $shouldAnimate?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  opacity: ${({ $shouldAnimate }) => ($shouldAnimate ? 1 : 0)};
  animation: ${({ $shouldAnimate }) => ($shouldAnimate ? slideInFromTop : 'none')} 0.7s ease-out;
  animation-fill-mode: forwards;
`;
